<template>
  <div>
      <div class="listing-content listing-content-locatorMap">
          <contact-contact-list/>
      </div>
    <div class="map">
      <contact-map/>
    </div>
  </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import {FETCH_CONTACTS} from './action';
    import {NAMESPACE} from './store';
    import ContactContactList from './ContactList';
    import ContactMap from './Map';

    export default {
        name: 'ContactAllTab',
        components: {
            ContactMap,
            ContactContactList
        },
        mounted() {
            this[FETCH_CONTACTS]()
        },
        methods: {
            ...mapActions(NAMESPACE, [FETCH_CONTACTS])
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/contact/AllTab.vue